<div class="dialog__header">
  <h1 class="dialog__title" mat-dialog-title>Contact Added</h1>
  <mat-icon mat-button mat-dialog-close class="dialog__icon dialog__close" fontIcon="close"></mat-icon>
</div>
<mat-dialog-content>
  <p>The new contact was created successfully. Please allow up to 5 minutes for it to appear in the contact list.</p>
  <p>Please contact support if the contact is not listed with 24 hours.</p>
  <mat-dialog-actions>
    <div>
      <button tabindex="-1" mat-raised-button [mat-dialog-close]="true">Ok</button>
    </div>
  </mat-dialog-actions>
</mat-dialog-content>
